module.exports = __webpack_public_path__ + "img/loading-border.51bf0b44.webp";